import { readStorage, writeStorage } from 'src/services/storage';
import type { Preference } from 'src/consts';

export const getPreferences = (): Preference => {
  return readStorage().preferences;
};

export const setPreference = <K extends keyof Preference>(key: K, val: Preference[K]): void => {
  const current = getPreferences();
  writeStorage({ preferences: { ...current, [key]: val } });
};
